import {
  AttendanceInfoType,
  mapAttendanceInfoType,
} from "./AttendanceInfoType";
import { mapPersonalInfoType, PersonalInfoType } from "./PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "./UserRoleInfoType";

export interface AttendanceTakenType {
  id?: number;
  contact_id?: number;
  personal_info_id?: number;
  daily_hours?: number;
  daily_wage?: number;
  payed?: number;
  status?: 1 | 0;
  attendanceData?: AttendanceInfoType | null;
  lastAttendanceData?: AttendanceInfoType | null;
  personalInfo?: PersonalInfoType | null;
  userRoleInfo?: UserRoleInfoType | null;
}

// to single object maping
export const mapAttendanceTakenType = (data: any): AttendanceTakenType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: AttendanceTakenType = {
    id: data.id,
    contact_id: data.contact_id,
    personal_info_id: data.personal_info_id,
    daily_hours: data.daily_hours,
    daily_wage: data.daily_wage,
    status: data.status,
    payed: data.payed,
    attendanceData:
      data.attendanceData !== null
        ? mapAttendanceInfoType(data.attendanceData)
        : null,
    lastAttendanceData:
      data.lastAttendanceData !== null
        ? mapAttendanceInfoType(data.lastAttendanceData)
        : null,
    personalInfo:
      data.personalInfo !== null
        ? mapPersonalInfoType(data.personalInfo)
        : null,
    userRoleInfo:
      data.userRoleInfo !== null
        ? mapUserRoleInfoType(data.userRoleInfo)
        : null,
  };
  return res;
};
 
// maping list objects
export const mapAttendanceTakenTypes = (data: any[]): AttendanceTakenType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapAttendanceTakenType);
};
